import { Analyst } from '@analysis/domain';

export interface FetchAnalystsOptions {
  canUseManagerReview: boolean;
  canUseReview: boolean;
  canUseAI: boolean;
  isAnalystManager: boolean;
  currentUserId: string;
}

/**
 * Whether the per-sample analyst list must be scoped to the current user's own
 * analyses. Each role checks its own review feature flag: an analyst manager is
 * scoped unless `canUseManagerReview`; any other user (e.g. a plain analyst) is
 * scoped unless `canUseReview`.
 */
export function scopeAnalystsToOwn(
  options: Pick<FetchAnalystsOptions, 'isAnalystManager' | 'canUseManagerReview' | 'canUseReview'>
): boolean {
  return options.isAnalystManager ? !options.canUseManagerReview : !options.canUseReview;
}

export interface AnalystRepository {
  getUserState(userId: string, sampleId: string): Promise<Analyst | undefined>;
  getHistory(historyId: string): Promise<Analyst | undefined>;
  fetchForSample(sampleId: string, options?: FetchAnalystsOptions): Promise<Analyst[]>;
  fetchUserAnalysts(sampleId: string, options: FetchAnalystsOptions): Promise<Analyst[]>;
  fetchAIAnalysts(sampleId: string): Promise<Analyst[]>;
}
